import { connect } from 'react-redux';
import InfoDetails from './InfoDetails';

const mapStateToProps = ({ pieceInfoReducer }) => ({ pieceInfoReducer });

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoDetails);
